import React from 'react';
import { Col, FormGroup } from 'reactstrap';

import { newDeepCopy } from '../../../../../utils/CommonUtils';
import NutrientsListItem from './NutrientsListItem';

const NutrientsList = props => {

    const { containerStyle } = styles;

    const checkNutriValue = (nutrient) => {
        let returnValue = '';
        props.item.nutrients.map(nutri => {
            if (nutri.id === nutrient.id) {
                returnValue = nutri.value;
            }
        });

        return returnValue;
    }

    const changeNutrients = (e, nutrient) => {
        
        if (Number(e.target.value) > 1000000) return;
        let modifiedNutrient = { ...nutrient, value: +e.target.value };
        let modifiedNutrients = newDeepCopy(props.item).nutrients;
        let alreadyAdded = false;
        let targetIndex = 0;

        modifiedNutrients.map((nutr, nutrIndex) => {
            if (nutr.id === nutrient.id) {
                alreadyAdded = true;
                targetIndex = nutrIndex
            }
        });

        if (alreadyAdded) {
            modifiedNutrients.splice(targetIndex, 1, modifiedNutrient);
        } else {
            modifiedNutrients.push(modifiedNutrient);
        }

        props.changeNutrientsState(modifiedNutrients);
    };

    return (
        <Col hidden={props.isHidden}>
            <FormGroup style={containerStyle}>
                {
                    props.nutrients.map((nutrient, i) => {

                        return <NutrientsListItem
                            key={`nutrients${i}`}
                            {...props}
                            nutrient={nutrient}
                            checkNutriValue={checkNutriValue}
                            changeNutrients={changeNutrients} />
                    })
                }
            </FormGroup>
        </Col>
    );
}

export default NutrientsList;

const styles = {
    containerStyle: {
        overflow: 'auto',
        marginBottom: 0,
        height: 'auto',
        paddingTop: 1
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/nutrients/NutrientsList.js